var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as rm from 'typed-rest-client';
var OrderService = /** @class */ (function () {
    function OrderService(shopUri) {
        this.restClient = new rm.RestClient('React-Frontend', shopUri);
        this.shopEndpoint = '/api/v2/shop/orders';
    }
    OrderService.prototype.getOrder = function (token, localeCode) {
        return __awaiter(this, void 0, void 0, function () {
            var endPoint;
            return __generator(this, function (_a) {
                endPoint = "".concat(this.shopEndpoint);
                if (!token) {
                    return [2 /*return*/, this.restClient
                            .create(endPoint, { localeCode: localeCode !== null && localeCode !== void 0 ? localeCode : 'de_DE' })
                            .then(function (data) {
                            if (data.result !== null) {
                                return data.result;
                            }
                            return {};
                        })];
                }
                return [2 /*return*/, this.restClient
                        .get("".concat(endPoint, "/").concat(token))
                        .then(function (data) {
                        if (data.result !== null) {
                            return data.result;
                        }
                        return {};
                    })];
            });
        });
    };
    OrderService.prototype.setPaymentMethod = function (token, paymentId, paymentMethod, orderUpdater) {
        return __awaiter(this, void 0, void 0, function () {
            var endPoint, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endPoint = "".concat(this.shopEndpoint, "/").concat(token, "/payments/").concat(paymentId);
                        return [4 /*yield*/, this.restClient.update(endPoint, { paymentMethod: "/api/v2/shop/payment-methods/".concat(paymentMethod) }, { additionalHeaders: { 'content-type': 'application/merge-patch+json' } })
                                .then(function (data) {
                                if (orderUpdater && data.result)
                                    orderUpdater(data.result);
                                return data;
                            })
                                .catch(function (error) { return ({
                                result: {
                                    statusCode: error.statusCode,
                                    message: JSON.parse(error.message),
                                },
                            }); })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.result];
                }
            });
        });
    };
    OrderService.prototype.setShipmentMethod = function (token, shipmentId, shippingMethod, orderUpdater) {
        return __awaiter(this, void 0, void 0, function () {
            var endPoint, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endPoint = "".concat(this.shopEndpoint, "/").concat(token, "/shipments/").concat(shipmentId);
                        return [4 /*yield*/, this.restClient.update(endPoint, { shippingMethod: "/api/v2/shop/shipping-methods/".concat(shippingMethod) }, { additionalHeaders: { 'content-type': 'application/merge-patch+json' } })
                                .then(function (data) {
                                if (orderUpdater && data.result)
                                    orderUpdater(data.result);
                                return data;
                            })
                                .catch(function (error) { return ({
                                result: {
                                    statusCode: error.statusCode,
                                    message: JSON.parse(error.message),
                                },
                            }); })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.result];
                }
            });
        });
    };
    OrderService.prototype.addItem = function (token, productVariant, quantity, orderUpdater) {
        return __awaiter(this, void 0, void 0, function () {
            var endPoint, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endPoint = "".concat(this.shopEndpoint, "/").concat(token, "/items");
                        return [4 /*yield*/, this.restClient.update(endPoint, {
                                productVariant: "/api/v2/shop/product-variants/".concat(productVariant.code),
                                quantity: quantity,
                            }, {
                                additionalHeaders: {
                                    'content-type': 'application/merge-patch+json',
                                },
                            })
                                .then(function (data) {
                                if (orderUpdater && data.result)
                                    orderUpdater(data.result);
                                return data;
                            })
                                .catch(function (error) { return ({
                                result: {
                                    statusCode: error.statusCode,
                                    message: JSON.parse(error.message),
                                },
                            }); })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.result];
                }
            });
        });
    };
    OrderService.prototype.setItemQuantity = function (token, orderItemId, quantity, orderUpdater) {
        return __awaiter(this, void 0, void 0, function () {
            var endPoint, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endPoint = "".concat(this.shopEndpoint, "/").concat(token, "/items/").concat(orderItemId);
                        return [4 /*yield*/, this.restClient.update(endPoint, { quantity: quantity }, { additionalHeaders: { 'content-type': 'application/merge-patch+json' } })
                                .then(function (data) {
                                if (orderUpdater && data.result)
                                    orderUpdater(data.result);
                                return data;
                            })
                                .catch(function (error) { return ({
                                result: {
                                    statusCode: error.statusCode,
                                    message: JSON.parse(error.message),
                                },
                            }); })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.result];
                }
            });
        });
    };
    OrderService.prototype.completeCheckout = function (token, orderUpdater) {
        return __awaiter(this, void 0, void 0, function () {
            var endPoint, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endPoint = "".concat(this.shopEndpoint, "/").concat(token, "/complete");
                        return [4 /*yield*/, this.restClient.update(endPoint, {}, {
                                additionalHeaders: {
                                    'content-type': 'application/merge-patch+json',
                                },
                            })
                                .then(function (data) {
                                if (orderUpdater && data.result)
                                    orderUpdater(data.result);
                                return data;
                            })
                                .catch(function (error) { return ({
                                result: {
                                    statusCode: error.statusCode,
                                    message: JSON.parse(error.message),
                                },
                            }); })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.result];
                }
            });
        });
    };
    OrderService.prototype.addAddress = function (token, address, orderUpdater) {
        return __awaiter(this, void 0, void 0, function () {
            var endPoint, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endPoint = "".concat(this.shopEndpoint, "/").concat(token, "/address");
                        return [4 /*yield*/, this.restClient.update(endPoint, {
                                billingAddress: address,
                                email: address.email,
                            }, {
                                additionalHeaders: {
                                    'content-type': 'application/merge-patch+json',
                                },
                            })
                                .then(function (data) {
                                if (orderUpdater && data.result)
                                    orderUpdater(data.result);
                                return data;
                            })
                                .catch(function (error) { return ({
                                result: {
                                    statusCode: error.statusCode,
                                    message: JSON.parse(error.message),
                                },
                            }); })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.result];
                }
            });
        });
    };
    OrderService.prototype.addIndividualization = function (token, individualizations, orderUpdater) {
        return __awaiter(this, void 0, void 0, function () {
            var endPoint, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endPoint = "".concat(this.shopEndpoint, "/").concat(token, "/individualization");
                        return [4 /*yield*/, this.restClient
                                .update(endPoint, __assign({}, individualizations), {
                                additionalHeaders: {
                                    'content-type': 'application/merge-patch+json',
                                },
                            })
                                .then(function (data) {
                                if (orderUpdater && data.result)
                                    orderUpdater(data.result);
                                return data;
                            })
                                .catch(function (error) { return ({
                                result: {
                                    statusCode: error.statusCode,
                                    message: JSON.parse(error.message),
                                },
                            }); })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.result];
                }
            });
        });
    };
    return OrderService;
}());
export { OrderService };
